import { render, staticRenderFns } from "./NewProductDestinazione.vue?vue&type=template&id=ee0827f4&"
import script from "./NewProductDestinazione.vue?vue&type=script&lang=js&"
export * from "./NewProductDestinazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports